import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { IonIcon, IonLabel } from '@ionic/angular';
import { Store } from '@ngrx/store';

import { NtyEmptyStateModule } from '@ninety/mobile/platform/components';
import { LanguageSelectors, UniversalCreateActions } from '@ninety/mobile/platform/state';

@Component({
  selector: 'nty-discussion-empty-state',
  imports: [AsyncPipe, IonIcon, IonLabel, NtyEmptyStateModule],
  template: `
    @let lang = discussionLanguage$ | async;
    @if (lang) {
      <div class="container">
        <ion-label>
          <nty-empty-state-graphic>
            <ion-icon src="assets/icons/one-on-one--duotone.svg" />
          </nty-empty-state-graphic>

          <nty-empty-state-title>It looks like you don’t have any {{ lang.quarterlyItems }} yet.</nty-empty-state-title>
          <nty-empty-state-description>
            Foster communication, growth, and recognition, building strong, thriving teams.
          </nty-empty-state-description>

          <nty-empty-state-btn (click)="onOpenUniversalCreate()">
            <ion-icon name="add-outline" size="16" />
            Create {{ lang.quarterlyItem }}
          </nty-empty-state-btn>
        </ion-label>
      </div>
    }
  `,
  styles: `
    :host {
      display: block;
      padding-left: 24px;
      padding-right: 24px;
    }

    ion-icon {
      padding-right: 10px;
    }

    ion-label {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-top: 60px;
    }
  `,
})
export class DiscussionEmptyStateComponent {
  private readonly store = inject(Store);

  readonly discussionLanguage$ = this.store.select(LanguageSelectors.discussionLanguage);

  onOpenUniversalCreate() {
    this.store.dispatch(UniversalCreateActions.open({ dispatchSource: 'DiscussionEmptyStateComponent' }));
  }
}
